export enum STORAGE_KEY {
	SESSION_ID = 'sessionId',
	PHONE = 'phone',
	ROLE = 'role',
	USER_ID = 'userId',
	IS_PASSWORD_CHANGED = 'isPasswordChanged',
	RECOVERY_DATE = 'recoveryDate',
}
